module.exports = __webpack_public_path__ + "img/icon_3d.eca4cab1.png";